import { render, staticRenderFns } from "./DeleteEmailTemplateDialog.vue?vue&type=template&id=e2a06c2a"
import script from "./DeleteEmailTemplateDialog.vue?vue&type=script&lang=js"
export * from "./DeleteEmailTemplateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports